import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Grid, Heart, User } from 'lucide-react';
export function MobileTabBar() {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  const navItems = [{
    icon: Home,
    label: 'Home',
    path: '/'
  }, {
    icon: Grid,
    label: 'Explore',
    path: '/explore'
  }, {
    icon: Heart,
    label: 'Favorites',
    path: '/favorites'
  }, {
    icon: User,
    label: 'Account',
    path: '/account'
  }];
  return <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 md:hidden z-50 safe-area-inset-bottom" data-id="element-126">
      <div className="flex justify-around items-center h-16 px-2" data-id="element-127">
        {navItems.map(item => {
        const active = isActive(item.path);
        return <Link key={item.path} to={item.path} className={`flex flex-col items-center justify-center gap-1 p-2 min-w-[64px] min-h-[56px] rounded-lg transition-colors ${active ? 'text-kithward-700' : 'text-gray-400'}`} data-id="element-128">
              <item.icon className={`w-6 h-6 ${active ? 'stroke-[2.5px]' : 'stroke-2'}`} data-id="element-129" />
              <span className={`text-xs font-medium ${active ? 'text-kithward-700' : 'text-gray-500'}`} data-id="element-130">
                {item.label}
              </span>
            </Link>;
      })}
      </div>
    </nav>;
}